import React, { useState } from 'react';
import HeaderDashboard from '../Components/HeaderDashboard';
import { getBookingSummary } from '../Services/ReservationsApi';

const MyBooking = () => {
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        service: "",
        bookingStatus: "",
        paymentStatus: "",
        referenceNo: "",
        pnrNo: "",
    })

    const [bookings, setBooking] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const params = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                GDSPNR: filters.pnrNo,
                TransactionID: "",
                ReferenceNo: filters.referenceNo,
                PaymentStatus: filters.paymentStatus,
                BookingStatus: filters.bookingStatus,
                Service: filters.service,
                UserName: "",
            };

            const data = await getBookingSummary(params);
            setBooking(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);

            const backendMessage =
                error.response?.data?.error ||  // <-- lowercase 'error' key from backend
                error.response?.data?.Error ||  // <-- fallback for uppercase
                "An unexpected error occurred.";
            alert(backendMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">My Booking</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/Settings/Bands" className="text-muted text-hover-primary">My Booking</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div class="row">
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">From Date</label>
                                <input class="form-control form-control-solid" name="fromDate" type="date" defaultValue="" placeholder=""
                                    value={filters.fromDate}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">To Date</label>
                                <input class="form-control form-control-solid" name="toDate" type="date" defaultValue="" placeholder=""
                                    value={filters.toDate}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">Services</label>
                                <select class="form-select form-select-solid" name="service"
                                    value={filters.service}
                                    onChange={handleChange}
                                >
                                    <option defaultValue="">--Select Type--</option>
                                    <option value="Flight">Flight</option>
                                    <option value="Hotel">Hotel</option>
                                    <option value="Bus">Bus</option>
                                    <option value="Cabs">Cabs</option>
                                    <option value="Visa">Visa</option>
                                    <option value="Forex">Forex</option>
                                    <option value="Insurance">Insurance</option>
                                    <option value="Rail">Rail</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">Booking Status</label>
                                <select class="form-select form-select-solid" name="bookingStatus"
                                    value={filters.bookingStatus}
                                    onChange={handleChange}
                                >
                                    <option defaultValue="">--Select Type--</option>
                                    <option value="ALL">ALL</option>
                                    <option value="OnRequest">OnRequest</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Blocked">Blocked</option>
                                    <option value="Released">Released</option>
                                    <option value="Hold">On Hold</option>
                                    <option value="Failure">Failed</option>
                                    <option value="Cancelled">Cancelled</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">Payment Status</label>
                                <select class="form-select form-select-solid" name="paymentStatus"
                                    value={filters.paymentStatus}
                                    onChange={handleChange}
                                >
                                    <option defaultValue="">--Select Type--</option>
                                    <option value="ALL">ALL</option>
                                    <option value="Success">Success</option>
                                    <option value="Failure">Failure</option>
                                    <option value="Requested">Requested</option>
                                    <option value="Refunded">Refunded</option>
                                    <option value="UnPaid">Block Orders</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">Reference No</label>
                                <input class="form-control form-control-solid" name="referenceNo" type="text" defaultValue="" placeholder="."
                                    value={filters.referenceNo}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">PNR No</label>
                                <input class="form-control form-control-solid" name="pnrNo" type="text" defaultValue="" placeholder="."
                                    value={filters.pnrNo}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <button type="button" class="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>
           
                 <div className="box_shadow mt-3">
                   <div class="box-repeater">
                    <div class="row">
                        <div class="col-md-8">
                        <h5>DEL-DXB</h5>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="d-flex-item">
                                    <span class="lbs_name">Booking Status </span>
                                    <span class="lbs_name_display">Confirmed</span>
                                    </div></div>
                                    <div class="col-md-6">
                                        <div class="d-flex-item"><span class="lbs_name">Payment Status </span><span class="lbs_name_display">Success</span>
                                        </div></div><div class="col-md-6">
                                            <div class="d-flex-item"><span class="lbs_name">Ticketing Status </span><span class="lbs_name_display">Confirmed</span></div></div>
                                            <div class="col-md-6"><div class="d-flex-item"><span class="lbs_name">Booking Date </span><span class="lbs_name_display">26 Nov 2025 12:55</span></div></div>
                                            <div class="col-md-6"><div class="d-flex-item"><span class="lbs_name">Travel Date </span><span class="lbs_name_display"></span></div></div>
                                            <div class="col-md-6"><div class="d-flex-item"><span class="lbs_name">Journey Type </span><span class="lbs_name_display"></span></div></div>
                                            <div class="col-md-6"><div class="d-flex-item"><span class="lbs_name">Contact </span><span class="lbs_name_display"></span></div></div>
                                            <div class="col-md-6"><div class="d-flex-item"><span class="lbs_name">Email </span><span class="lbs_name_display"></span></div></div></div></div>
                                            <div class="col-md-4"><div class="main_info"><div class="d-flex-item"><span class="lbs_name">PNR </span><span class="lbs_name_display">-</span></div>
                                            <div class="d-flex-item"><span class="lbs_name">RefNo. </span><span class="lbs_name_display">TFF349</span></div><div class="d-flex-item"><span class="lbs_name">Amount </span><span class="lbs_name_display">24682.00</span></div></div>
                                            <button class="btn btn-primary btn-sm m-1">Booking Details</button><button class="btn btn-primary btn-sm m-1">Change/Cancel Booking</button><button class="btn btn-primary btn-sm m-1">Print Ticket</button><button class="btn btn-primary btn-sm m-1">Re-Schedule Ticket</button></div></div></div>
                </div>
            </section>

        </>

    )
};

export default MyBooking;

